module.exports = __webpack_public_path__ + "img/DE05776.0c8de7ed.png";